/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import App from "./App.vue";

window._ = require("lodash");

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; // Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

// axios
import axios from "./axios.js";
Vue.prototype.$http = axios;

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// Leaflet CSS
import "leaflet/dist/leaflet.css";

// Global Pagination Component
import pagination from "./components/Pagination";
Vue.component("pagination", pagination);

// Vue Select Component
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

// VTooltip for tooltips
import VTooltip from "v-tooltip";
Vue.use(VTooltip);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// VeeValidate for Form Validation (Versión 2.x)
import VeeValidate, { Validator } from "vee-validate";
import es from "vee-validate/dist/locale/es"; // Importación del idioma español para vee-validate
Vue.use(VeeValidate);

// Configuración de VeeValidate para español
Validator.localize("es", es); // Configuración del idioma español como predeterminado

// Feather font icon
require("./assets/css/iconfont.css");

// Vuexy Admin Filters
import "./filters/filters";

// VeeValidate rules
import "./utils/validations";

// Keycloak for Authentication
import { keycloak } from "./api";
Vue.prototype.$keycloak = keycloak;

// Google Maps Configuration
import * as VueGoogleMaps from "vue2-google-maps";
import { GOOGLE_MAPS_API_KEY } from "./constants/config";
Vue.use(VueGoogleMaps, {
  load: {
    key: GOOGLE_MAPS_API_KEY,
    libraries: "places,drawing,visualization", // This is required if you use the Autocomplete plugin
  },
  installComponents: true,
});

Vue.config.productionTip = false;

// Keycloak Initialization and App Mounting
keycloak
  .init({
    onLoad: "login-required",
  })
  .then(function (authenticated) {
    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount("#app");

    // Token Refresh Interval
    setInterval(() => {
      keycloak
        .updateToken(70)
        .success((refreshed) => {
          if (refreshed) {
            console.log("Token refreshed" + refreshed);
          } else {
            console.log(
              "Token not refreshed, valid for " +
                Math.round(
                  keycloak.tokenParsed.exp +
                    keycloak.timeSkew -
                    new Date().getTime() / 1000
                ) +
                " seconds"
            );
          }
        })
        .error(() => {
          console.log("Failed to refresh token");
        });
    }, 90001);
  })
  .catch(function () {
    console.log("Failed to initialize Keycloak.");
  });
